import React, { useEffect, useState } from 'react';
import { GAME } from '@push.io/shared';
import type { MenuLanguage, ServerStats } from './types.js';

function useFps(): number | null {
  const [fps, setFps] = useState<number | null>(null);
  useEffect(() => {
    let frames = 0;
    let last = performance.now();
    let raf = 0;
    const tick = (now: number): void => {
      frames += 1;
      if (now - last >= 1000) {
        setFps(Math.round((frames * 1000) / (now - last)));
        frames = 0;
        last = now;
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
  return fps;
}

export function Footer({ language, stats, showPing, showFps, onPrivacy, onTerms }: {
  language: MenuLanguage; stats: ServerStats | null; showPing: boolean; showFps: boolean;
  onPrivacy: () => void; onTerms: () => void;
}) {
  const fps = useFps();
  const tr = (es: string, en: string, fr: string) => language === 'es' ? es : language === 'fr' ? fr : en;
  return <footer className="main-menu-footer">
    <div className="footer-copyright">© 2026 RL Studios | {tr('Todos los derechos reservados.', 'All rights reserved.', 'Tous droits réservés.')}</div>
    <div className="footer-metrics">
      {(showPing && stats) || showFps ? (
        <div className="footer-metrics-row">
          {showPing && stats && <span>Ping: {stats.ping} ms</span>}
          {showFps && <span>FPS: {fps ?? '—'}</span>}
        </div>
      ) : null}
      <span className="footer-version">v{GAME.GAME_VERSION}</span>
    </div>
    <div className="footer-links">
      <button onClick={onPrivacy}>{tr('Privacidad', 'Privacy', 'Confidentialité')}</button>
      <button onClick={onTerms}>{tr('Términos', 'Terms', "Conditions d'utilisation")}</button>
    </div>
  </footer>;
}
